export const getFiscalYearEnd = (date?: string) => {
  const fiscalYearDate = date ? new Date(date) : new Date()
  return Number(fiscalYearDate.getFullYear().toString())
}

export const getDate = (date?: string | null | undefined) => {
  return date ? new Date(date) : undefined
}
